module.exports = __webpack_public_path__ + "static/media/19.12e0e6e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/19.png
// module id = 871
// module chunks = 0